module.exports = __webpack_public_path__ + "img/differences_mobile.5d9c5aed.jpg";